import styled from 'styled-components';

export const StyledDiv = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    padding-bottom: 10px;
    padding-top: ${({ paddingTop }) => paddingTop};
`;

export const StyledPrices = styled.div`
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    padding: ${({ padding }) => padding};
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin};
`;
